import { CachedEventRegistry } from 'app/shared/events/cached_event_registry';

/**
 * Passes through to the document, abstracts away any browser compatibility
 */
export class HTMLDomDocumentService {
    private pageVisibilityEvent: CachedEventRegistry;

    constructor() {
        this.pageVisibilityEvent = new CachedEventRegistry<boolean[]>();

        let hidden;
        let visibilityChange;
        if (typeof document['hidden'] !== 'undefined') {
            // Opera 12.10 and Firefox 18 and later support
            hidden = 'hidden';
            visibilityChange = 'visibilitychange';
        } else if (typeof document['msHidden'] !== 'undefined') {
            hidden = 'msHidden';
            visibilityChange = 'msvisibilitychange';
        } else if (typeof document['webkitHidden'] !== 'undefined') {
            hidden = 'webkitHidden';
            visibilityChange = 'webkitvisibilitychange';
        }
        document.addEventListener(visibilityChange, () => {
            this.pageVisibilityEvent.notifyListeners(!document[hidden]);
        });
        // Fire off the first event for caching
        this.pageVisibilityEvent.notifyListeners(!document[hidden]);
    }

    /**
     * Calls back true of the page is visible and false if the page is hidden
     * @param handler
     */
    addOnPageVisibilityChangedHandler(handler: (boolean) => void): () => void {
        return this.pageVisibilityEvent.addEventListener(handler);
    }
}
